import {
  EmployerFooter,
  EmployerHeader,
  type EmployerSiteName,
} from '@seek/adv-header-footer';
import type { Locale } from '@seek/melways-sites';
import { Box } from 'braid-design-system';
import type { ChangeEvent } from 'react';

import { isStaging } from 'src/app/utils/environment';
import { extractChildrenOfName } from 'src/app/v2/utils/extractReactChildren';
import type { HeaderFooterContext } from 'src/graphql/generated';

import * as styles from './index.css';

interface MainLayoutProps {
  children: React.ReactNode;
  headerFooterContext?: HeaderFooterContext | null;
  locale: Locale;
  site: EmployerSiteName;
  basicHeader: boolean;
  onToggleButtonClick?:
    | ((event: ChangeEvent<HTMLInputElement>) => void)
    | undefined;
}

export const MainLayout: React.FunctionComponent<MainLayoutProps> = ({
  basicHeader,
  children,
  headerFooterContext,
  onToggleButtonClick,
  site,
  locale,
}) => {
  const beforeHeaderChildren = extractChildrenOfName(children, 'BeforeHeader');
  const afterHeaderChildren = extractChildrenOfName(children, 'AfterHeader');

  return (
    <Box
      display="flex"
      flexDirection="column"
      style={{ height: '100vh', width: '100vw' }}
    >
      {beforeHeaderChildren}
      <EmployerHeader
        {...headerFooterContext}
        site={site}
        locale={locale}
        isStaging={isStaging()}
        basic={basicHeader}
        onToggleButtonClick={onToggleButtonClick}
      />
      {afterHeaderChildren}
      <Box background="body" component="main" style={{ flex: '1 1 auto' }}>
        <Box
          className={styles.bodyLayout}
          width="full"
          height="full"
          overflow="hidden"
        >
          {children}
        </Box>
      </Box>
      <EmployerFooter
        {...headerFooterContext}
        basic
        site={site}
        locale={locale}
        isStaging={isStaging()}
      />
    </Box>
  );
};

export const BeforeHeader: React.FunctionComponent<
  React.PropsWithChildren
> = () => <></>;

BeforeHeader.displayName = 'BeforeHeader';

export const AfterHeader: React.FunctionComponent<
  React.PropsWithChildren
> = () => <></>;

AfterHeader.displayName = 'AfterHeader';
